export default __webpack_public_path__ + "static/media/lesson.6617ab3b.svg";